/* ============================================================
   CHECKPOINT LEVELS — Global Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── HEADER SCROLL SHADOW ─────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── MOBILE DRAWER ────────────────────────────────────────
  const drawerOpen  = document.querySelectorAll('[data-drawer-open]');
  const drawerClose = document.querySelectorAll('[data-drawer-close]');
  const drawer      = document.getElementById('mobile-drawer');
  const backdrop    = drawer?.querySelector('.drawer-backdrop');

  const openDrawer  = () => { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; };
  const closeDrawer = () => { drawer.classList.remove('open'); document.body.style.overflow = ''; };

  drawerOpen.forEach(btn => btn.addEventListener('click', openDrawer));
  drawerClose.forEach(btn => btn.addEventListener('click', closeDrawer));
  backdrop?.addEventListener('click', closeDrawer);

  // ── QUANTITY SELECTOR ────────────────────────────────────
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input   = selector.querySelector('input');
    const btnMinus = selector.querySelector('[data-qty-minus]');
    const btnPlus  = selector.querySelector('[data-qty-plus]');

    btnMinus?.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });

    btnPlus?.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      const max = parseInt(input.getAttribute('max')) || 999;
      if (val < max) input.value = val + 1;
    });
  });

  // ── TABS ─────────────────────────────────────────────────
  document.querySelectorAll('[data-tabs]').forEach(tabGroup => {
    const buttons = tabGroup.querySelectorAll('.tab-btn');
    const panels  = document.querySelectorAll('[data-tab-panel]');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.getAttribute('data-tab');
        buttons.forEach(b => b.classList.remove('active'));
        panels.forEach(p => p.hidden = (p.getAttribute('data-tab-panel') !== target));
        btn.classList.add('active');
      });
    });
  });

  // ── ACCORDIONS ───────────────────────────────────────────
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const body = document.getElementById(trigger.getAttribute('aria-controls'));

      trigger.setAttribute('aria-expanded', !expanded);
      if (body) {
        body.hidden = expanded;
        body.style.display = expanded ? 'none' : 'block';
      }
    });
  });

  // ── CART FORM — ADD TO CART FEEDBACK ─────────────────────
  const addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart-btn]');
      if (!btn) return;

      const original = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      const formData = new FormData(form);
      formData.append('sections', 'cart-icon-bubble');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (res.ok) {
          btn.textContent = 'Added!';
          btn.style.background = '#1a7a1a';

          // Update cart count
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          document.querySelectorAll('.cart-count').forEach(el => {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });

          setTimeout(() => {
            btn.textContent = original;
            btn.style.background = '';
            btn.disabled = false;
          }, 2500);
        } else {
          throw new Error('Add to cart failed');
        }
      } catch {
        btn.textContent = 'Try Again';
        btn.style.background = '#991111';
        setTimeout(() => {
          btn.textContent = original;
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
      }
    });
  });

  // ── IMAGE GALLERY (Product Page) ─────────────────────────
  const mainImage = document.querySelector('[data-main-image]');
  const thumbs    = document.querySelectorAll('[data-thumb]');

thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;

      // Update active state
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      // Get the full-size src from data-src attribute
      const src = thumb.getAttribute('data-src');
      if (!src) return;

      let mainImg = mainImage.querySelector('img');

      if (mainImg) {
        // Fade out, swap src, fade in
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.15s ease';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.srcset = '';
          mainImg.style.opacity = '1';
        }, 150);
      } else {
        // No img tag yet — create one
        mainImage.innerHTML = '';
        const newImg = document.createElement('img');
        newImg.src = src;
        newImg.alt = '';
        newImg.style.cssText = 'width:100%;height:100%;object-fit:contain;padding:16px;';
        mainImage.appendChild(newImg);
      }
    });
  });

  // ── ANNOUNCEMENT BAR CLOSE ────────────────────────────────
  const annClose = document.querySelector('[data-announcement-close]');
  const annBar   = document.querySelector('.announcement-bar');
  annClose?.addEventListener('click', () => {
    if (annBar) annBar.style.display = 'none';
  });

  // ── SCROLL REVEAL ─────────────────────────────────────────
  const reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    reveals.forEach(el => revealObserver.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('revealed'));
  }

});

// ── REVEAL ANIMATIONS (inject CSS) ───────────────────────────
const style = document.createElement('style');
style.textContent = `
  [data-reveal] {
    opacity: 0;
    transform: translateY(24px);
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
  [data-reveal].revealed {
    opacity: 1;
    transform: translateY(0);
  }
  [data-reveal][data-delay="1"] { transition-delay: 0.1s; }
  [data-reveal][data-delay="2"] { transition-delay: 0.2s; }
  [data-reveal][data-delay="3"] { transition-delay: 0.3s; }
  [data-reveal][data-delay="4"] { transition-delay: 0.4s; }
  .img-placeholder img { transition: opacity 0.15s ease; }
`;
document.head.appendChild(style);
